module.exports = __webpack_public_path__ + "static/media/navbar.e92cca57.svg";